module.exports = __webpack_public_path__ + "src/img/cookies/cookies-header.6bb12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/cookies-header.jpg
// module id = 248
// module chunks = 0